import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { Field } from "../../component";
import CustomDropdown from "../../container/reusableComponent/Dropdown/CustomDropdown";
const OptionsField = props => {
  const [panelKey, setPanelKey] = useState(0);
  const options = ["Option 1", "Option 2", "Option 3"];
  const {
    label,
    formData,
    isRequiredField,
    optionsList,
    onChange,
    name,
    showRequiredError,
    onSelectedField,
    placeholderName,
    isTopMarginRequired,
    onBlur = value => {},
    value,
    error
  } = props;
  return (
    <Form.Group
      className={`${
        showRequiredError && formData === "" && isTopMarginRequired
          ? "mt-3"
          : ""
      } select-option-field`}
    >
      <Form.Label>
        {label} {isRequiredField ? <span className="required">*</span> : <></>}
      </Form.Label>
      {label == "Meeting Type" ? (
        <>
          {/* Not working please fix datta ji*/}
          <CustomDropdown
            options={[
              { value: "", label: "Select meeting type" },
              ...(optionsList || []).map(item => ({
                value: item,
                label: item
              }))
            ]}
            height={"43px"}
            className={"create-agenda"}
            page={"create-agenda"}
            menuClassName={"createAgendaMenu"}
            onChange={event => onChange(event, name)}
            value={formData}
            error={error}
          />
          {/* <div className="form-field">
            <Field
              className={`${
                showRequiredError && formData === "" ? "is-invalid" : ""
              } ${formData === "" || !formData ? "color-of-placeholder" : ""} `}
              as="select"
              key="venue"
              keyName="venue"
              value={formData}
              onChange={event => onChange(event, name)}
              onClick={event => onSelectedField(event, name)}
              onBlur={onBlur}
            >
              <>
                <option value="" className="option-placeholder">
                  Select {placeholderName}
                </option>
                {(optionsList || []).map(value => {
                  return (
                    <>
                      {typeof value === "object" ? (
                        <option
                          value={value.id}
                          key={value.id}
                          name={value.name}
                        >
                          {value.name}
                        </option>
                      ) : (
                        <option value={value} key={value}>
                          {value}
                        </option>
                      )}
                    </>
                  );
                })}
              </>
            </Field>
          </div> */}
        </>
      ) : (
        <div className="form-field">
          <Field
            className={`${
              showRequiredError && formData === "" ? "is-invalid" : ""
            } ${formData === "" || !formData ? "color-of-placeholder" : ""} `}
            as="select"
            key="venue"
            keyName="venue"
            value={formData}
            onChange={event => onChange(event, name)}
            onClick={event => onSelectedField(event, name)}
            onBlur={onBlur}
          >
            <>
              <option value="" className="option-placeholder">
                Select {placeholderName}
              </option>
              {(optionsList || []).map(value => {
                return (
                  <>
                    {typeof value === "object" ? (
                      <option value={value.id} key={value.id} name={value.name}>
                        {value.name}
                      </option>
                    ) : (
                      <option value={value} key={value}>
                        {value}
                      </option>
                    )}
                  </>
                );
              })}
            </>
          </Field>
        </div>
      )}
    </Form.Group>
  );
};
export default OptionsField;
